import React, { useContext, useEffect, useState } from 'react';

import {
    MaterialReactTable
} from "material-react-table";
import { User2Icon } from 'lucide-react';
import { base_url } from '../../config';
import axios from 'axios';
import RegistrationContext from '../../contexts/RegistrationContext';

const Sent = () => {
    const [data, setData] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const { reload, setReload } = useContext(RegistrationContext);
    const [reloadingRow, setReloadingRow] = useState("");


    useEffect(() => {
        axios.get(`${base_url}/api/admin/get-codes/sent`)
            .then((response) => setData(response.data))
            .catch((error) => console.error('Error fetching students:', error));
    }, []);

    const handleMarkAsSent = async (row: any) => {
        try {
            setReloadingRow(row.code);
            const r = await axios.post(`${base_url}/api/admin/code-action`,
                { id: row.code, action: 'unsent' })

            // remove row from data
            setData((prevData: any) => prevData.filter((item: any) => item.code !== row.code));
        } catch (error: any) {
            console.error('Error marking as sent:', error);
        } finally {
            setReloadingRow("");
        }

    }


    const handleDelete = async (row: any) => {
        try {
            setReloadingRow(row.code);
            const r = await axios.post(`${base_url}/api/admin/code-action`,
                { id: row.code, action: 'delete' })

            // remove row from data
            setData((prevData: any) => prevData.filter((item: any) => item.code !== row.code));
        } catch (error: any) {
            console.error('Error marking as sent:', error);
        } finally {
            setReloadingRow("");
        }

    }
    const handleCopy = (code: string) => {
        navigator.clipboard.writeText(code)
            .then(() => {
                alert("Code copied to clipboard!");
            })
            .catch((error) => {
                console.error("Failed to copy code:", error);
            });
    };

    const columns = [
        {
            accessorKey: 'code',
            header: 'Code',
            Cell: ({ row }: { row: { original: { code: string, created_at:string } } }) => {
                if (reloadingRow === row.original.code) {
                    return (<div>loading</div>)
                }
                return (

                    <div className="flex items-center gap-2">
                        <span>{row.original.code}</span>
                        <button
                            onClick={() => handleCopy(row.original.code)}
                            className="text-blue-600 hover:text-blue-800 text-sm font-medium"
                        >
                            Copy
                        </button>
                    </div>)

            }
            ,
        },
        {
            id: 'created_at',
            header: 'Created At',
            sortable: true,
            Cell: ({ row }: { row: { original: { code:string, created_at: string } } }) => {
                     const date = new Date(row.original.created_at);
                     return (
                         <span>{date.toLocaleDateString()} </span>
                     )
                
                
            },
        },
        {
            id: 'actions',
            header: 'Actions',
            Cell: ({ row }: { row: { original: { code: string, created_at:string } } }) => (
                <div className="flex gap-2">
                    {/* Mark as Sent Button */}
                    <button
                        onClick={() => handleMarkAsSent(row.original)}
                        className="flex items-center gap-2 px-6 py-4 border rounded-xl border-blue-600 text-blue-800 hover:bg-blue-800 hover:text-white text-sm h-6"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="w-4 h-4"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M5 13l4 4L19 7"
                            />
                        </svg>
                        Mark as not sent
                    </button>

                    {/* Delete Button */}
                    <button
                        onClick={() => handleDelete(row.original)}
                        className="flex items-center gap-2 px-6 py-4 border  rounded-xl border-red-600 text-red-800 hover:bg-red-800 hover:text-white text-sm h-6"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="w-4 h-4"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                        Delete
                    </button>
                </div>
            ),
        }
    ];

    const handleAction = (row: any) => {

        axios.post(`${base_url}/api/admin/impersonate`,
            { id: row.code })
            .then((response) => setReload(reload + 1))
            .catch((error) => console.error('Error impersonating:', error));
    };

    return <>

        <div style={{ flex: '1 1 0', paddingBottom: '20px' }}>
            <MaterialReactTable columns={columns} data={data} />
        </div>

    </>;
};


export default Sent;
